export default "__VITE_ASSET__Dl0vEX6X__"